import LogoMark from "./LogoMark";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="bg-black px-5 py-10 text-white md:px-8 md:py-12">
            <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
                <div className="flex items-center gap-3">
                    <LogoMark className="h-7 w-7" bg="#E31B23" fg="#FFFFFF" />
                    <span className="font-logo text-xl font-bold italic leading-none md:text-2xl">
                        Money Mac Media
                        <sup className="text-[0.5em]">®</sup>
                    </span>
                </div>
                <div className="flex flex-wrap items-center gap-6 font-mono text-[10px] uppercase tracking-[0.2em] md:text-xs">
                    <a
                        data-testid="footer-email-link"
                        className="transition-colors duration-300 hover:text-mmm-red"
                        href="mailto:hello@moneymacmedia.com"
                    >
                        hello@moneymacmedia.com
                    </a>
                </div>
            </div>
            <div className="mt-10 border-t border-white/15 pt-6 font-mono text-[10px] uppercase tracking-[0.16em] text-white/50 md:text-xs">
                <p>Money Mac Media® — A Money Mac Media Company</p>
                <p className="mt-2">
                    <span className="text-mmm-red">Look rich.</span> Make something.
                </p>
                <p data-testid="footer-artists-paid" className="mt-2">
                    <span className="text-mmm-red">Artists paid.</span> In full. Every
                    time.
                </p>
            </div>
            <div className="mt-6 flex flex-col gap-3 font-mono text-[9px] uppercase tracking-[0.16em] text-white/40 md:flex-row md:items-center md:justify-between md:text-[10px]">
                <span data-testid="footer-copyright">
                    © {year} Money Mac Media — A Money Mac Media Company
                </span>
                <span>All rights reserved. Some wrongs reserved.</span>
            </div>
        </footer>
    );
}
